import BaseComponent from "@js/components/base_component.jsx";

class EuiSendingDomainsIndexTable extends BaseComponent {

  render() {
    return ( this.props.table && this.props.table.length > 0 ) ? (
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="column-name">{ t("headings.domain") }</th>
            <th className="column-name">{ t("headings.tracking_domain") }</th>
            <th className="column-name" style={{width: "100px"}}>{ t("headings.dkim_mode") }</th>
            <th className="column-name text-center" style={{width: "80px"}}>{ t("headings.dns") }</th>
            <th className="column-name text-center" style={{width: "80px"}}>{ t("headings.sending_enabled") }</th>
            <th className="column-actions" style={{width: "100px"}}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{this._renderRows()}</tbody>
      </table>
    ) : this.props.filtered ? (
      <EmptyTableNotification
        text={ I18n.t("phrases.no_sending_domains_match") }
        offerNew={ false }
      />
    ) : (
      <EmptyTableNotification
        type={I18n.t("sections.sending_domains")}
        offerNew={ true }
      />
    );
  }

  _renderRows() {
    return this.props.table.map((sd, i) => {
      return (
        <tr key={ i }>
          <td>{ sd.domain }</td>
          <td>{ sd.tracking_domain }</td>
          <td>{ I18n.t("sending_domain_dkim_modes_short." + sd.dkim_mode) }</td>
          <td className="text-center">
            { !sd.dns_verified
              ? <span className="text-muted"><i className="fa fa-times" /></span>
              : ( sd.dns_regression
                  ? <span className="text-muted"><i className="fa fa-check" /> <TooltipLink text={ <i className="fa fa-exclamation-triangle text-muted" /> } tooltip={ I18n.t("phrases.dns_status_regression_note") } /></span>
                  : <span className="text-muted"><i className="fa fa-check" /></span>
                )
            }
          </td>
          <td className="text-center">
            { !sd.dns_verified
              ? <span className="text-muted" title={ I18n.t("phrases.dns_not_verified_cannot_send") }>&mdash;</span>
              : ( sd.sending_enabled
                  ? <span className="text-muted"><i className="fa fa-check" /></span>
                  : <span className="text-muted"><i className="fa fa-times" /></span>
                )
            }
          </td>
          <td className="text-right index-buttons">
            {
              sd.id && (
                <div>
                  <ButtonView
                    href={ Routes.eui_sending_domain_path(sd.id) }
                    size="small"
                  />
                </div>
              )
            }
          </td>
        </tr>
      );
    });
  }

}

export default EuiSendingDomainsIndexTable;
